import { buildBaseIntegrationEntity } from '@vy/services';
import { INTEGRATION_PROVIDERS, SYNC_STATUSES } from '@vy/types';
import { isNullOrUndefined } from '@vy/utils';
import type { FormattedIntegrationProduct } from './types/formatted-integration-product';

export function createNetSuiteIntegrationEntity(product: FormattedIntegrationProduct | null) {
  if (isNullOrUndefined(product)) {
    return undefined;
  }

  const now = new Date();

  const integrationEntity = buildBaseIntegrationEntity(
    INTEGRATION_PROVIDERS.netSuite,
    product.id,
    SYNC_STATUSES.Synced,
    now,
  );

  const integrationEntityWithMetadata = {
    ...integrationEntity,
    metadata: {
      name: product.name,
      id: product.id,
    },
  };

  return integrationEntityWithMetadata;
}

export function createQuickBooksIntegrationEntity(product: FormattedIntegrationProduct | null) {
  if (isNullOrUndefined(product)) {
    return undefined;
  }

  const now = new Date();

  const integrationEntity = buildBaseIntegrationEntity(
    INTEGRATION_PROVIDERS.quickBooks,
    product.id,
    SYNC_STATUSES.Synced,
    now,
  );

  const integrationEntityWithMetadata = {
    ...integrationEntity,
    metadata: {
      name: product.name,
      id: product.id,
    },
  };

  return integrationEntityWithMetadata;
}

export function createXeroIntegrationEntity(product: FormattedIntegrationProduct | null) {
  if (isNullOrUndefined(product)) {
    return undefined;
  }

  const now = new Date();

  const integrationEntity = buildBaseIntegrationEntity(
    INTEGRATION_PROVIDERS.xero,
    product.id,
    SYNC_STATUSES.Synced,
    now,
  );

  const integrationEntityWithMetadata = {
    ...integrationEntity,
    metadata: {
      name: product.name,
      id: product.id,
    },
  };

  return integrationEntityWithMetadata;
}

export function createPaddleIntegrationEntity(product: FormattedIntegrationProduct | null) {
  if (isNullOrUndefined(product)) {
    return undefined;
  }

  const now = new Date();

  const integrationEntity = buildBaseIntegrationEntity(
    INTEGRATION_PROVIDERS.paddle,
    product.id,
    SYNC_STATUSES.Synced,
    now,
  );

  const integrationEntityWithMetadata = {
    ...integrationEntity,
    metadata: {
      name: product.name,
      id: product.id,
    },
  };

  return integrationEntityWithMetadata;
}
